import { ApiService } from './../../services/api.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NodeUi } from "classes/NodeUi";
import { ExpressionMethodDto } from "dto/ExpressionMethodDto";
import { FlowService } from "services/flow.service";

@Component({
  selector: 'expression-editor',
  templateUrl: './expression-editor.component.html',
  styleUrls: ['./expression-editor.component.css']
})
export class ExpressionEditorComponent implements OnInit {

  // Two-way binding
  private expressionString:string;
  @Input()
  get expression() {return this.expressionString;}
  set expression(val:string) {
    this.expressionString = val;
    this.expressionChange.emit(this.expressionString);
  }
  @Output() expressionChange = new EventEmitter();

  @Input() nested:boolean;

  expressionMethods:ExpressionMethodDto[];
  
  constructor(api:ApiService) {
    api.getExpressionMethods().subscribe((data)=>
      this.expressionMethods = data.filter((item)=> (this.nested && item.AllowInNested) || !this.nested)
    );
  }

  ngOnInit() {
    
  }

}



// WEBPACK FOOTER //
// C:/git/flowdesigner/src/app/expression-editor/expression-editor.component.ts